import { useState } from 'react';
import { useListServerlessTasks } from '@/service/serverless-gpu/hook';
import ServerlessTaskSearch, {
  FormSchemaFilter,
} from '../../tasks/task-search';
import { WrapTableAndSheet } from '../../tasks/tasks';
import { ServerlessTask } from '@/service/serverless-gpu/type';
import { useParams } from 'react-router-dom';
import { RouteParams } from '@/router/type';
import { isDateInRange, compareDateDesc } from '@/utils/date';
import { Button } from '@/components/ui/button';
import { RefreshCwIcon } from 'lucide-react';

const ServerlessDetailTasks = () => {
  const [filter, setFilter] = useState<FormSchemaFilter>();
  const { projectId } = useParams<RouteParams>();

  const { data, isLoading, refetch } = useListServerlessTasks(
    {
      project_id: projectId,
    },
    {
      refetchInterval: 1000 * 60,
    }
  );

  const filterData = (
    data: ServerlessTask[],
    filter: FormSchemaFilter = {}
  ) => {
    return data.filter((item) => {
      if (filter?.taskId && !item.id.includes(filter.taskId)) return false;
      if (
        filter?.status &&
        filter?.status?.length > 0 &&
        !filter.status.includes(item.status)
      )
        return false;
      if (filter?.type && item.trigger_type !== filter.type) return false;
      if (!isDateInRange(item.created_at, filter?.date)) return false;
      return true;
    });
  };

  const result = data
    ? filterData(data.tasks, filter)
        .map((data) => ({
          id: data.id,
          name: data.name,
          status: data.status,
          created_at: data.created_at,
          type: data.trigger_type,
          project_id: data.project_id,
        }))
        .sort(compareDateDesc('created_at'))
    : [];
  return (
    <div>
      <div className="container mt-8">
        <div className="mb-4 flex flex-col items-start gap-4">
          <div className="w-full">
            <ServerlessTaskSearch
              onSearch={(data) => {
                setFilter(data);
              }}
            />
          </div>
          <Button
            variant="outline"
            onClick={() => refetch()}
            size={'sm'}
            startIcon={<RefreshCwIcon className="h-4 w-4" />}
            disabled={isLoading}
          >
            Refresh
          </Button>
        </div>
        <WrapTableAndSheet data={result} isLoading={isLoading} />
      </div>
    </div>
  );
};

export default ServerlessDetailTasks;
